import { processData } from "@/mocks/homeData";
import AnimatedSection from "@/components/AnimatedSection";

export default function ProcessSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="container-astro">
        <AnimatedSection>
          <div className="text-center mb-14 md:mb-18">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 mb-5 font-heading tracking-tight">
              {processData.heading}
            </h2>
            <div className="w-16 h-1 bg-accent-500 rounded-full mx-auto" />
          </div>
        </AnimatedSection>

        {/* Desktop: Horizontal timeline */}
        <div className="hidden lg:block">
          <div className="relative">
            {/* Horizontal connecting line */}
            <div className="absolute top-[52px] left-[7%] right-[7%] h-px bg-gradient-to-r from-accent-500/20 via-accent-500/40 to-accent-500/20" />

            <div className="grid grid-cols-7 gap-4">
              {processData.steps.map((step, i) => (
                <AnimatedSection key={step.number} delay={i * 120}>
                  <div className="text-center group">
                    {/* Number circle */}
                    <div className="relative inline-flex items-center justify-center w-[52px] h-[52px] rounded-full bg-background-100 border-2 border-accent-500/30 text-accent-600 font-extrabold text-sm font-heading mb-5 mx-auto group-hover:bg-accent-500 group-hover:text-background-50 group-hover:border-accent-500 transition-all duration-300 z-10">
                      {step.number}
                    </div>

                    <h3 className="text-sm font-bold text-foreground-950 mb-2 font-heading">
                      {step.title}
                    </h3>
                    <p className="text-xs text-foreground-500 leading-relaxed max-w-[140px] mx-auto">
                      {step.desc}
                    </p>
                  </div>
                </AnimatedSection>
              ))}
            </div>
          </div>
        </div>

        {/* Mobile/Tablet: Vertical timeline */}
        <div className="lg:hidden">
          <div className="relative max-w-md mx-auto">
            {/* Vertical connecting line */}
            <div className="absolute left-[25px] top-0 bottom-0 w-px bg-gradient-to-b from-accent-500/30 via-accent-500/50 to-accent-500/30" />

            <div className="flex flex-col gap-8">
              {processData.steps.map((step, i) => (
                <AnimatedSection key={step.number} delay={i * 100}>
                  <div className="flex items-start gap-5 group">
                    {/* Number circle */}
                    <div className="relative z-10 flex items-center justify-center w-[52px] h-[52px] rounded-full bg-background-100 border-2 border-accent-500/30 text-accent-600 font-extrabold text-sm font-heading shrink-0 group-hover:bg-accent-500 group-hover:text-background-50 group-hover:border-accent-500 transition-all duration-300">
                      {step.number}
                    </div>

                    <div className="pt-2.5">
                      <h3 className="text-base font-bold text-foreground-950 mb-1.5 font-heading">
                        {step.title}
                      </h3>
                      <p className="text-sm text-foreground-500 leading-relaxed">
                        {step.desc}
                      </p>
                    </div>
                  </div>
                </AnimatedSection>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}